// frontend/src/utils/dateFormatter.js

const STORE_TIMEZONE = 'Europe/London';

/**
 * Format date to UK timezone
 * @param {string|Date} date - The date to format
 * @param {string} format - Format type: 'date', 'datetime', 'time'
 * @returns {string} Formatted date string
 */
export const formatDate = (date, format = 'date') => {
  if (!date) return '-';
  
  const dateObj = new Date(date);
  
  const options = {
    timeZone: STORE_TIMEZONE,
  };
  
  switch (format) {
    case 'datetime':
      return dateObj.toLocaleString('en-GB', {
        ...options,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    
    case 'time':
      return dateObj.toLocaleTimeString('en-GB', {
        ...options,
        hour: '2-digit',
        minute: '2-digit',
      });
    
    case 'date':
    default:
      return dateObj.toLocaleDateString('en-GB', {
        ...options,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      });
  }
};

/**
 * Format date for display in tables (UK timezone)
 */
export const formatTableDate = (date) => {
  return formatDate(date, 'date');
};

/**
 * Format datetime for detailed views (UK timezone)
 */
export const formatDateTime = (date) => {
  return formatDate(date, 'datetime');
};